import { render } from "./SettingsWorkspaces.vue?vue&type=template&id=c20f7bc2"
import script from "./SettingsWorkspaces.vue?vue&type=script&lang=js"
export * from "./SettingsWorkspaces.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__